






















import { Vue, Component } from 'vue-property-decorator'

@Component
export default class Zoom extends Vue {
  private _zoom (amount: number) {
    if (amount === 0) {
      Vue.prototype.$fontSize = 16
    } else {
      Vue.prototype.$fontSize += amount
    }
    document.documentElement.style.fontSize = Vue.prototype.$fontSize + 'px'
    localStorage.setItem('fontSize', Vue.prototype.$fontSize.toString())
  }

  public zoomHandler (event: any, zoomAmount: number) {
    // If the icon is clicked, target the button to blur
    if (event.target.tagName === 'BUTTON') {
      event.target.blur()
    } else {
      event.path[1].blur()
    }

    this._zoom(zoomAmount)
  }
}
